import { render, staticRenderFns } from "./SaveSearchModal.vue?vue&type=template&id=5ed70710"
import script from "./SaveSearchModal.vue?vue&type=script&lang=js"
export * from "./SaveSearchModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports